const MyVisitor = {

    // PAGE HEADER
    "my_visitors": "My Visitors",

    // FIELDS
    "search": "Search",
    "status": "Status",
    "date": "Date",
    "type": "Type",
    "type_resident": "Resident",
    "type_service_provider": "Service Provider",
    "type_visitor": "Visitor",
    "type_delivery": "Delivery",
    "type_premise_staff": "Premise Staff",

    // TABLE HEADERS
    "table_visitor_name": "VISITOR NAME",
    "table_type": "TYPE",
    "table_delivery_partner": "DELIVERY PARTNER",
    "table_unit": "UNIT",
    "table_purpose": "PURPOSE",
    "table_entry_type": "ENTRY TYPE",
    "table_status": "STATUS",
    "table_in_time": "IN TIME",
    "table_out_time": "OUT TIME",
}

export default MyVisitor;